import { gsap } from 'gsap'
import CustomEase from 'js/vendors/gsap-member/esm/CustomEase'

import { lerp, roundEx } from 'js/utils/Maths'
import Common from 'js/_core/Common'

gsap.registerPlugin(CustomEase)

// gsap カスタムイージングを返す
export function getCubicCurve(a, b, c, d) {
  // "M0,0 C"+a+","+b+" "+c+","+d+" 1,1"
  return CustomEase.create('custom', `M0,0 C${Number(a)},${Number(b)} ${Number(c)},${Number(d)} 1,1`)
}

//　ハイフンで単語を区切って返す
export function toKebabCase(str) {
  if (typeof str !== 'string') return str

  str = str.replace(/^ *?[A-Z]/, function (allStr) {
    return allStr.toLowerCase()
  })
  str = str.replace(/_/g, '-')
  str = str.replace(/ *?[A-Z]/g, function (allStr, i) {
    return '-' + allStr.replace(/ /g, '').toLowerCase()
  })
  return str
}

// 0で桁を埋める
export function zeroPadding(num, length = 2, isSplit = true) {
  let html = ''
  num = ('000' + num).slice(-length)
  if (isSplit) {
    num = num.split('')
    num.forEach((value, index) => {
      html += '<span class="js-split p-split">' + value + '</span>'
    })
  } else {
    html = num
  }
  return html
}

// 画像をロード、ロード完了後のタイミングを返す
export async function imageLoad(src) {
  await new Promise((resolve) => {
    let image = new Image()
    image.src = src

    image.onload = () => {
      resolve(image)
    }

    image.onerror = () => {
      resolve('')
    }
  })
}

export function canPlayWebM() {
  var video = document.createElement('video')
  return video.canPlayType('video/webm; codecs="vp8, vorbis"')
}

export function get100dvh() {
  const $dummyElement = document.createElement('div')
  $dummyElement.style.height = '100dvh'
  $dummyElement.style.position = 'fixed'
  $dummyElement.style.top = '0'
  $dummyElement.style.left = '0'
  $dummyElement.style.opacity = '0'

  document.body.appendChild($dummyElement)
  const height = $dummyElement.getBoundingClientRect().height
  document.body.removeChild($dummyElement)

  return height
}

export async function videoLoad({
  resourceInfo = {},
  onComplete = () => {},
  options = {
    loop: true,
    currentTime: 0,
    muted: true,
  },
}) {
  await new Promise((resolve) => {
    const video = document.createElement('video')

    let canplayWebm = canPlayWebM() === 'probably' || canPlayWebM() === 'maybe'

    if (resourceInfo.webmSrc && canplayWebm) {
      const source = document.createElement('source')
      source.src = resourceInfo.webmSrc
      video.appendChild(source)
    }

    if (resourceInfo.src) {
      const source = document.createElement('source')
      source.src = resourceInfo.src
      video.appendChild(source)
    }

    video.crossOrigin = 'anonymous'
    // video.currentTime = 1
    // video.lastFrame = !1
    video.preload = 'none'
    video.loop = options.loop
    video.currentTime = options.currentTime
    video.muted = options.muted
    // video.src = resourceInfo.src
    // video.src = sources
    video.setAttribute('webkit-playsinline', 'webkit-playsinline')
    video.setAttribute('playsinline', 'playsinline')
    if (video.muted) {
      video.setAttribute('muted', 'muted')
    }
    resourceInfo.video = video

    if (resourceInfo.classlist && resourceInfo.classlist.length) {
      resourceInfo.classlist.forEach((classItem) => {
        video.classList.add(classItem)
      })
    }

    deepMerge(video, resourceInfo.attrs)

    video.addEventListener('canplaythrough', () => {
      // video.pause()
      resolve()
      onComplete(resourceInfo)
    })

    video.load()
    // video.onloadedmetadata = () => {
    //   resolve()
    //   onComplete(resourceInfo)
    // }

    video.addEventListener('error', () => {
      console.log('video load error')
      resolve()
      onComplete(resourceInfo)
    })
  })
}

// イベントを強制発火させる
export function triggerEvent(element, event) {
  if (document.createEvent) {
    // IE以外
    const evt = document.createEvent('HTMLEvents')
    evt.initEvent(event, true, true) // event type, bubbling, cancelable
    return element.dispatchEvent(evt)
  } else {
    // IE
    const evt = document.createEventObject()
    return element.fireEvent('on' + event, evt)
  }
}

// 指定要素の祖先要素リストを取得する
export function getParents(elem) {
  let parents = []
  for (; elem && elem !== document; elem = elem.parentNode) parents.push(elem)

  return parents
}

// 指定要素のx,y座標を取得
export function getTargetOffset(target) {
  return {
    top: getTargetOffsetTop(target),
    left: getTargetOffsetLeft(target),
  }
}

// 指定要素のy座標を取得
export function getTargetOffsetTop(target, useTransform = false) {
  let rect = target.getBoundingClientRect()
  // let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  let scrollTop = Common.scroll.lastScroll || window.pageYOffset || document.documentElement.scrollTop
  let translateY = 0

  if (useTransform) {
    translateY = getTranslate(target).y
  }

  return rect.top + scrollTop - translateY
}

export function getContentWidth(element) {
  const style = getComputedStyle(element)
  const paddingLeft = parseFloat(style.paddingLeft)
  const paddingRight = parseFloat(style.paddingRight)
  return element.clientWidth - paddingLeft - paddingRight
}

// 指定要素のx座標を取得
export function getTargetOffsetLeft(target, useTransform = false) {
  if (!target) return
  let rect = target.getBoundingClientRect()
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  let translateX = 0

  if (useTransform) {
    translateX = getTranslate(target).x
  }

  return rect.left + scrollLeft - translateX
}

export function getTargetOffsetCenterTop(target, st) {
  let rect = target.getBoundingClientRect()
  let targetHeight = rect.height
  let wH = window.innerHeight
  let scrollTop = st || window.pageYOffset || document.documentElement.scrollTop

  if (wH > targetHeight) {
    return rect.top + scrollTop - (wH - targetHeight) * 0.5
  } else {
    return rect.top + scrollTop + (targetHeight - wH) * 0.5
  }
}

export function getIsPassive() {
  if (typeof window === 'object' && typeof window.addEventListener === 'function' && Object.defineProperty) {
    let passive = false
    const options = Object.defineProperty({}, 'passive', {
      get() {
        passive = true
      },
    })
    window.addEventListener('test', null, options)

    return passive
  }
}

export function getTranslate(el) {
  const translate = {}
  if (!window.getComputedStyle) return

  const style = getComputedStyle(el)
  const transform = style.transform || style.mozTransform

  let mat

  if (transform) {
    mat = transform.match(/^matrix3d\((.+)\)$/)
  }

  if (mat) {
    translate.x = parseFloat(mat[1].split(', ')[12])
    translate.y = parseFloat(mat[1].split(', ')[13])
    translate.z = parseFloat(mat[1].split(', ')[14])

    return translate
    // return parseFloat( mat[ 1 ].split( ', ' )[ 13 ] );
  }

  if (transform) {
    mat = transform.match(/^matrix\((.+)\)$/)
  }

  translate.x = mat ? parseFloat(mat[1].split(', ')[4]) : 0
  translate.y = mat ? parseFloat(mat[1].split(', ')[5]) : 0
  translate.z = 0

  return translate
}

export function setTransform($element, x, y, delay, digit = 1000) {
  let transform

  if (!delay) {
    // transform = `translate(${x}px,${y}px)`

    transform = `translate(${x}px,${y}px) rotate(.0001deg)`
  } else {
    const start = getTranslate($element)
    const lerpX = roundEx(lerp(start.x, x, delay), digit)
    const lerpY = roundEx(lerp(start.y, y, delay), digit)
    transform = `translate(${lerpX}px,${lerpY}px) rotate(.0001deg)`
  }

  $element.style.transform = transform
}

export function setTransform3d({ $element, x = 0, y = 0, delay = 0, digit = 1000, useRotate = false }) {
  let transform

  if (!delay) {
    if (useRotate) {
      transform = `translate3d(${x}px,${y}px,0)`
    } else {
      transform = `translate3d(${x}px,${y}px,0) rotate(.0001deg)`
    }
  } else {
    const start = getTranslate($element)
    const lerpX = roundEx(lerp(start.x, x, delay), digit)
    const lerpY = roundEx(lerp(start.y, y, delay), digit)

    if (useRotate) {
      transform = `translate3d(${lerpX}px,${lerpY}px,0)`
    } else {
      transform = `translate3d(${lerpX}px,${lerpY}px,0) rotate(.001deg)`
    }
  }

  $element.style.transform = transform
}

export function setElementHide($element, disableClick = true) {
  if ($element && $element instanceof HTMLElement) {
    $element.style.opacity = 0

    if (disableClick) {
      $element.style.visibility = 'hidden'
      $element.style.userSelect = 'none'
      $element.style.pointerEvents = 'none'
    }
  }
}

export function copyTextToClipboard(textVal) {
  const $copySrc = document.createElement('textarea')
  $copySrc.textContent = textVal

  const $body = document.body
  $body.appendChild($copySrc)
  $copySrc.select()
  const retVal = document.execCommand('copy')
  $body.removeChild($copySrc)

  return retVal
}

export function arrayShuffle([...array]) {
  for (let i = array.length - 1; i >= 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

export function arrayReverse(array) {
  if (!Array.isArray(array)) {
    throw new TypeError('引数は配列である必要があります。')
  }
  return [...array].reverse()
}

export function isTouchDevice() {
  if (navigator.maxTouchPoints > 0) {
    return true
  }

  if (navigator.msMaxTouchPoints > 0) {
    return true
  }

  if (window.matchMedia('(pointer:coarse)').matches) {
    return true
  }

  if ('orientation' in window) {
    return true
  }

  return window.navigator.userAgentData && navigator.userAgentData.mobile
}

export function htmlToNode(htmlStr) {
  if (!htmlStr || typeof htmlStr !== 'string') {
    return
  }

  const tmpElem = document.createElement('div')
  tmpElem.innerHTML = htmlStr

  return tmpElem.childNodes
}

export function clearTween(tween) {
  if (tween) {
    tween.pause()
    tween.kill()
    tween = null
  }
}

export function pauseTween(tween) {
  if (tween) {
    tween.pause()
  }
}

export function getStyle($element, styleName) {
  let styleValue = ''
  if ($element) {
    let style = getComputedStyle($element)
    if (style) {
      styleValue = style[styleName] || ''
    }
  }

  return styleValue
}

export function clearInlineStyle($element, styleNames) {
  if ($element) {
    if ($element.length || $element.length === 0) {
      $element.forEach(($elementItem) => {
        styleNames.forEach((styleNameItem) => {
          $elementItem.style[styleNameItem] = ''
        })
      })
    } else {
      styleNames.forEach((styleNameItem) => {
        $element.style[styleNameItem] = ''
      })
    }
  }
}

export function removeElement($element) {
  if ($element && $element instanceof HTMLElement) {
    const $parent = $element.parentNode

    if ($parent) {
      $parent.removeChild($element)
    }
  }
}

export function strToObject(str) {
  return new Function('return ' + str)()
}

export function getUrlQueries() {
  const queryStr = window.location.search.slice(1)
  let queries = {}

  // クエリがない場合は空のオブジェクトを返す
  if (!queryStr) {
    return queries
  }

  // クエリ文字列を & で分割して処理
  queryStr.split('&').forEach(function (queryStr) {
    // = で分割してkey,valueをオブジェクトに格納
    const queryArr = queryStr.split('=')
    queries[queryArr[0]] = queryArr[1]
  })

  return queries
}

export function checkTagKind($el, tagName) {
  if (!$el) return false

  const elTagName = $el.tagName.toLowerCase()
  tagName = tagName.toLowerCase()

  return elTagName === tagName
}

export function isArray(value) {
  return Array.isArray(value)
}

export function getRandomElement(arr) {
  if (!Array.isArray(arr) || arr.length === 0) {
    return []
  }

  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

export function getRandomObjectChild(obj) {
  const keys = Object.keys(obj)
  if (keys.length === 0) return null

  const randomKey = keys[Math.floor(Math.random() * keys.length)]
  // return obj[randomKey]
  return {
    name: randomKey,
    value: obj[randomKey],
  }
}

export function getRandomColor() {
  let color = Math.floor(Math.random() * 0xffffff).toString(16)
  for (let count = color.length; count < 6; count++) {
    color = '0' + color
  }

  return '#' + color
}

export function generateArray(numElements, amount = 1) {
  let result = []
  let midpoint = Math.floor(numElements / 2)
  for (let i = 0; i < numElements; i++) {
    result.push((i - midpoint) * amount)
  }
  return result
}

export function addBreak($element) {
  if ($element) {
    let content = $element.innerHTML.trim()

    // 「」で閉じられた部分を特定し、その中の文末記号の後に<br>を追加しないようにする
    let protectedAreas = []
    let re = /「[^」]*[。！？][^」]*」/g
    let match
    while ((match = re.exec(content)) !== null) {
      protectedAreas.push([match.index, match.index + match[0].length])
    }

    function inProtectedArea(index) {
      for (let area of protectedAreas) {
        if (index >= area[0] && index <= area[1]) return true
      }
      return false
    }

    // 最後の文末記号以前の文末記号の後ろに<br>を追加する
    content = content.replace(/(。|！|？)(?!」)/g, (match, p1, offset) => {
      // 保護されたエリア内の場合は<br>を追加しない
      if (inProtectedArea(offset)) return p1
      return p1 + '<br>'
    })

    $element.innerHTML = content
  }
}

export function replaceColorCode(code) {
  if (code.startsWith('#') && (code.length === 7 || code.length === 4)) {
    return '0x' + code.slice(1)
  }
  return code
}

export function hexToRgb(hex) {
  // 入力の文字列の長さと形式を確認
  if (hex.length !== 7 || !hex.startsWith('#')) {
    return null
  }

  // 2文字ずつr, g, bを取得
  let r = parseInt(hex.substring(1, 3), 16)
  let g = parseInt(hex.substring(3, 5), 16)
  let b = parseInt(hex.substring(5, 7), 16)

  return `rgb(${r},${g},${b})`
}

export function hexToNormalizedRgbArray(hex) {
  // 入力の文字列の長さと形式を確認
  if (hex.length !== 7 || !hex.startsWith('#')) {
    return null
  }

  // 2文字ずつr, g, bを取得し、255で割って正規化
  let r = parseInt(hex.substring(1, 3), 16) / 255
  let g = parseInt(hex.substring(3, 5), 16) / 255
  let b = parseInt(hex.substring(5, 7), 16) / 255

  return [r, g, b]
}

export function camelToSnakeCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
}

export function remToPixels(rem) {
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
}

export function get100lvh() {
  // 計測用要素を作成
  const probe = document.createElement('div')
  // 見えない＆レイアウトに影響しないように
  probe.style.cssText = `
    position: fixed;
    inset: 0;
    height: 100lvh;
    width: 0;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
  `
  document.documentElement.appendChild(probe)

  // 実ピクセル値を取得（小数を含む）
  const px = probe.getBoundingClientRect().height

  // 後始末
  probe.remove()
  return px // 例: 844 など
}

export function deepMerge(target, ...sources) {
  if (!sources.length) return target

  const source = sources.shift()

  if (typeof target !== 'object' || target === null) return target
  if (typeof source !== 'object' || source === null) return target

  for (const key in source) {
    if (!source.hasOwnProperty(key)) continue

    const sourceValue = source[key]
    const targetValue = target[key]

    if (isPlainObject(sourceValue)) {
      if (!isPlainObject(targetValue)) {
        target[key] = {}
      }
      deepMerge(target[key], sourceValue) // ← 参照保持しながら再帰的にマージ
    } else {
      target[key] = sourceValue // ← 上書き
    }
  }

  return deepMerge(target, ...sources)
}
export function isPlainObject(obj) {
  return typeof obj === 'object' && obj !== null && obj.constructor === Object && Object.prototype.toString.call(obj) === '[object Object]'
}